import { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const [keyword, setKeyword] = useState("");

  const filtered = faqs.filter(
    (f) => f.q.toLowerCase().includes(keyword.toLowerCase()) || f.a.toLowerCase().includes(keyword.toLowerCase())
  );

  return (
    <Layout>
      <PageHero
        eyebrow="FAQ"
        title="よくあるご質問"
        description="お気軽にお問い合わせください。"
        image="images/faq.webp"
      />

      <section className="bg-background-50 py-20 md:py-28">
        <div className="mx-auto max-w-3xl px-4 md:px-10">
          <div className="mb-10 relative">
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="キーワードで検索（例：見積、対応エリア）"
              className="w-full bg-background-100 border border-background-200 rounded-md pl-11 pr-4 py-3.5 text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400"
            />
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500 text-lg"></i>
          </div>

          <div className="space-y-3">
            {filtered.length === 0 && (
              <p className="text-center text-foreground-600 py-10 text-sm">
                該当する質問が見つかりませんでした。
              </p>
            )}
            {filtered.map((f, idx) => {
              const isOpen = openIdx === idx;
              return (
                <div key={f.q} className="bg-background-100 rounded-lg border border-background-200 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? null : idx)}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-7 py-5 text-left cursor-pointer whitespace-nowrap"
                  >
                    <span className="flex items-start gap-3 flex-1 whitespace-normal">
                      <span className="font-heading text-accent-600 mt-0.5">Q.</span>
                      <span className="text-sm md:text-base font-medium text-foreground-950">{f.q}</span>
                    </span>
                    <span
                      className={`w-8 h-8 flex items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-transform ${
                        isOpen ? "rotate-45 bg-primary-500 border-primary-500 text-background-50" : ""
                      }`}
                    >
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 md:px-7 pb-6 pt-0 border-t border-background-200">
                      <div className="flex items-start gap-3 pt-4">
                        <span className="font-heading text-primary-600">A.</span>
                        <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{f.a}</p>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="mt-14 bg-primary-900 text-background-50 rounded-lg p-8 text-center">
            <h3 className="font-heading text-xl md:text-2xl mb-3">解決しないご質問がある場合は</h3>
            <p className="text-sm text-background-200 mb-6">
              お電話またはお問い合わせフォームから、お気軽にご相談ください。
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-medium px-6 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors"
            >
              お問い合わせフォームへ
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}